import { Datalayer } from "@omnia/shared/layers/datalayer";
import { FieldViewModel, getDistinctValues, ILayerViewModel, isArray, selectMany } from "../../omnia"
import { ol_Feature } from "@omnia/exports/openlayers";

export type CroppingProvider = () => FieldViewModel[];
export type LayerProvider = () => ILayerViewModel[];

export class MapFilter {

    private _disabledFields: FieldViewModel[];
    private _disabledCropping: FieldViewModel[];


    constructor(private _fullCropping: FieldViewModel[], private _providers: CroppingProvider[], private _visibleLayersProvider: LayerProvider) {
        this._providers = _providers || [];
        this._visibleLayersProvider = _visibleLayersProvider || (() => []);
    }

    addProvider(provider: CroppingProvider): Function {

        if (this._providers.indexOf(provider) < 0) {
            this._providers.push(provider);
            this.update();
            return () => this.removeProvider(provider);
        }

        return () => undefined;

    }

    removeProvider(provider: CroppingProvider) {
        this._providers.remove(p => p == provider);
        this.update();
    }

    update() {

        let hiddenCropping = getDistinctValues(selectMany(this._providers.map(p => p())).filter(a => !!a), c => c, c => c.croppingId);

        let hiddenFields = hiddenCropping.map(c => c.fieldVm);
        hiddenFields = getDistinctValues(hiddenFields, f => f, f => f.fieldId);

        let visibleFields = this._fullCropping.map(c => c.fieldVm);

        hiddenFields = hiddenFields.filter(f => visibleFields.indexOf(f) < 0);

        this._disabledFields = hiddenFields;
        this._disabledCropping = hiddenCropping;

    }

    public filterFeatureSelection(feature: ol_Feature) {

        let layers = this._visibleLayersProvider();

        if (isArray(layers)) {
            let r = layers.some(l => l.mapLayer && l.mapLayer.getFeatures().some(f => f == feature));
            if (!r) return false;
        }

        let layer = feature.get("layer");

        if (layer instanceof Datalayer) {

            let croppingId = layer.croppingId;
            if (croppingId && this._disabledCropping.some(c => c.croppingId == croppingId)) {
                return false;
            }

        }

        let data = feature.get("data");

        let r = [this._disabledFields, this._disabledCropping].some(d => d && d.some(f => f == data));

        return !r;

    }

}
